/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskPPPLoansScan } from './ExecRiskPPPLoansScan';
import {
    ExecRiskPPPLoansScanFromJSON,
    ExecRiskPPPLoansScanFromJSONTyped,
    ExecRiskPPPLoansScanToJSON,
} from './ExecRiskPPPLoansScan';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedPPPLoansScanResponse
 */
export interface ExecRiskPaginatedPPPLoansScanResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedPPPLoansScanResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskPPPLoansScan>}
     * @memberof ExecRiskPaginatedPPPLoansScanResponse
     */
    results: Array<ExecRiskPPPLoansScan>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedPPPLoansScanResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedPPPLoansScanResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedPPPLoansScanResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedPPPLoansScanResponse interface.
 */
export function instanceOfExecRiskPaginatedPPPLoansScanResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedPPPLoansScanResponseFromJSON(json: any): ExecRiskPaginatedPPPLoansScanResponse {
    return ExecRiskPaginatedPPPLoansScanResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedPPPLoansScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedPPPLoansScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskPPPLoansScanFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedPPPLoansScanResponseToJSON(value?: ExecRiskPaginatedPPPLoansScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskPPPLoansScanToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

